import { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';

import { ApolloClient, InMemoryCache } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import { ApolloProvider } from '@apollo/client/react';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import { ThemeProvider } from '@bluecodecom/theme';

import './i18n';
import { configService } from './services';

const App = lazy(() => import('./app'));

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: `https://terms-api.${configService.domain}/client/graphql`,
  }),
});

const Main = () => (
  <ThemeProvider observe>
    <LoaderProvider>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <Routes>
            <Route
              path=":serviceName/:kind/:version/:language"
              element={<App />}
            />
          </Routes>
        </BrowserRouter>
      </ApolloProvider>
    </LoaderProvider>
  </ThemeProvider>
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Main />,
);
